import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import ProfileSetup from "@/pages/ProfileSetup";
import ProfileView from "@/pages/ProfileView";
import Search from "@/pages/Search";
import Shortlist from "@/pages/Shortlist";
import Messages from "@/pages/Messages";
import Notifications from "@/pages/Notifications";
import Premium from "@/pages/Premium";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Admin from "@/pages/Admin";
import Welcome from "@/pages/Welcome";
import MobileStickyCTA from "@/components/MobileStickyCTA";

function AppRouter() {
    const location = useLocation();

    // Process Emergent Auth callback during render to avoid race conditions
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }

    const isAuthPage = ["/login", "/register"].includes(location.pathname);
    const isWelcomePage = location.pathname === "/welcome";

    return (
        <>
            {!isAuthPage && !isWelcomePage && <Navbar />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/welcome" element={<Welcome />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/search" element={<Search />} />
                <Route path="/profile/:id" element={<ProfileView />} />

                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/profile/setup" element={<ProtectedRoute><ProfileSetup /></ProtectedRoute>} />
                <Route path="/shortlist" element={<ProtectedRoute><Shortlist /></ProtectedRoute>} />
                <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
                <Route path="/premium" element={<ProtectedRoute><Premium /></ProtectedRoute>} />
                <Route path="/premium/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            </Routes>
            {!isAuthPage && !isWelcomePage && <Footer />}
            <MobileStickyCTA />
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                    <Toaster position="top-center" richColors />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
